import styled from '@emotion/styled';
import { Colors } from 'styles/variables/colors';
import { ReactComponent as CrossSimpleIconComponent } from 'assets/icons/cross-simple.svg';

type Props = {
    isActive?: boolean;
};

export const Explanation = styled.span<Props>`
    cursor: pointer;
`;

export const Container = styled.div`
    max-width: 406px;
    border: 1px solid lightgray;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 4px;
    gap: 0.4rem;
    min-width: 250px;
`;

export const Row = styled.div`
    display: flex;
    align-items: center;
`;

export const FullExplanation = styled.div`
    padding: 13px 20px;
    max-height: 320px;
    overflow-y: auto;

    .quill,
    .ql-container,
    .ql-editor {
        border: none;
        font-family: 'Assistant', sans-serif !important;
        font-size: 15px !important;
        line-height: 20px !important;
    }

    a {
        color: #6d41d8;
        text-decoration: underline;
        overflow-wrap: anywhere;
    }

    a:hover {
        color: #8353e2;
    }
`;

export const CrossSimpleIcon = styled(CrossSimpleIconComponent)`
    fill: ${Colors.darkGray};
`;
